import { useCallback } from 'react';
import { useRecoilState } from 'recoil';

import { documentUploadProgressMap, DocumentUploadProgressState } from '../state/atoms/documentUpload';

export const useDocumentUploadState = (docId: string) => {
  const [ uploadProgressMap, setUploadProgressMap ] = useRecoilState(documentUploadProgressMap);
  const uploadProgress = uploadProgressMap[docId]?.uploadProgress ?? 0;
  const isUploading = uploadProgressMap[docId]?.uploading ?? false;
  const isUploaded = uploadProgressMap[docId]?.uploaded ?? false;

  const updateUploadProgress = useCallback((uploadProgress: DocumentUploadProgressState) => {
    return setUploadProgressMap((prevUploadProgressMap) => ({
      ...prevUploadProgressMap,
      [docId]: uploadProgress,
    }));
  }, [ docId, setUploadProgressMap ]);

  const resetUploadProgressState = useCallback(() => {
    return setUploadProgressMap((prevUploadProgressMap) => ({
      ...prevUploadProgressMap,
      [docId]: {
        uploaded: false,
        uploading: false,
        uploadProgress: 0,
      },
    }));
  }, [ docId, setUploadProgressMap ]);

  return {
    isUploading,
    isUploaded,
    uploadProgress,
    updateUploadProgress,
    resetUploadProgressState,
  };
};
